import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'
import cl from 'classnames'
export const Tags = ({ tags, chosen, setChosen }) => {
	const {
		i18n: { language },
	} = useTranslation()
	const addToList = (code) => {
		if (chosen.includes(code)) setChosen(chosen.length === 1 ? ['all'] : chosen.filter((item) => item !== code))
		else setChosen(code === 'all' ? ['all'] : chosen.filter((item) => item !== 'all').concat(code))
	}
	return (
		<div>
			{tags.map((tag) => {
				return (
					<button className={cl(styles.button, {
						[styles.active]: chosen.includes(tag.code)
					})} key={tag.code} onClick={() => addToList(tag.code)}>
						#{language === 'rus' ? tag.nameRu : tag.nameKz}
					</button>
				)
			})}
		</div>
	)
}
